import React from 'react'
import styled from 'styled-components'
import { GradientText } from './gradient-text'
import { mobile } from '../utils/media-query'

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background: black;
    font-family: 'PT Mono', monospace;
    font-weight: bold;
    padding: 7px 25px;
    font-size: 16px;

    ${mobile.css`
        font-size: 15px;
    `}
`

type GradientTextColorButtonProps = {
    text: string
    color?: string
}
const GradientTextColorButton = ({ text, color }: GradientTextColorButtonProps) => (
    <Container>{color ? <span style={{ color }}>{text}</span> : <GradientText>{text}</GradientText>}</Container>
)

export default GradientTextColorButton
